export function _getUrlParams(name, url) {
    let m,
        reg,
        tmp;
    name = name || ''
    url = (url || window.location.href).split('#');
    // console.log(`url: `, url)
    if (name && name.indexOf('#') !== -1) {
        tmp = url.length < 2 ? '' : url[1];
    } else {
        tmp = url[0];
    }
    m = tmp.match(new RegExp('(|[?&#])' + name.replace('#', '') + '=([^#&?]*)(\\s||$)', 'gi'));
    if (m) {
        return decodeURIComponent(m[0].split('=')[1]);
    } else {
        return '';
    }
}

export function _getUrlParamsObject(url) {
    var i
    url = url || window.location
    url = url.indexOf ? url : url.toString()
    url = decodeURIComponent(url)

    var paramStringStart = url.indexOf('?') + 1,
        paramStringEnd = (url.indexOf('#') === -1) ? url.length : url.indexOf('#'),
        paramString = url.slice(paramStringStart, paramStringEnd),
        keysAndValues = paramString.split('&'),
        paramsObject = {}

    for (i = 0; i < keysAndValues.length; i++) {
        var keyValue = keysAndValues[i].split('=')

        if (keyValue[0].slice(-2) === '[]') {
            var key = keyValue[0].slice(0, -2)
            paramsObject[key] = paramsObject[key] || []
            paramsObject[key].push(keyValue[1])
        } else {
            paramsObject[keyValue[0]] = keyValue[1]
        }
    }

    return paramsObject
}

export function _parseUrl(url = location.href) {
    let a = document.createElement('a')
    a.href = url
    return {
        source: url,
        protocol: a.protocol.replace(':', ''),
        host: a.hostname,
        port: a.port,
        query: a.search,
        params: (function () {
            let ret = {}
            let seg = a.search.replace(/^\?/, '').split('&')
            let len = seg.length
            let i = 0
            let s
            for (; i < len; i++) {
                if (!seg[i]) {
                    continue
                }
                s = seg[i].split('=')
                ret[s[0]] = s[1]
            }
            return ret
        })(),
        file: (a.pathname.match(/\/([^\/?#]+)$/i) || [, ''])[1],
        hash: a.hash.replace('#', ''),
        path: a.pathname.replace(/^([^\/])/, '/$1'),
        relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [, ''])[1],
        segments: a.pathname.replace(/^\//, '').split('/')
    }
}

/**
 * 获取 url 上的参数值
 * @param {string} key
 * @returns {*}
 * @private
 */
export function _getPageUrlParams(key) {
    return _parseUrl().params[key]
}

export function _appendUrlParam(url, key, value) {
    let separator = url.indexOf('?') > -1 ? '&' : '?'
    let extraParam = `${separator}${key}=${value}`
    url += extraParam
    return url;
}

export function _http2https(adUnits) {
    var httpsMap = {
        'http://cdn-adn.rayjump.com': 'https://cdn-adn-https.rayjump.com',
        'http://res.rayjump.com': 'https://res-https.rayjump.com',
        'http://d11kdtiohse1a9.cloudfront.net': 'https://res-https.rayjump.com'
    }
    for (var i = 0; i < adUnits.length; i++) {
        for (var k in adUnits[i]) {
            for (var key in httpsMap) {
                var reg = new RegExp('' + key + '')
                if (reg.test(adUnits[i][k])) {
                    adUnits[i][k] = adUnits[i][k].replace(reg, httpsMap[key])
                }
            }
        }
    }
}

/* 使用JS原生方法获取id元素或者class元素 */
export function _getEl(el, tagName) {
    el = el.replace(/^\s|\s$/g, '')
    // # id . class tag
    var first = el.substr(0, 1)
    // console.log(first);

    if (first === '#') {
        return document.getElementById(el.substr(1, el.length))
    }

    if (first === '.') {
        return document.getElementsByClassName(el.substr(1, el.length))
    }
}

/* 使用JS原生方法删除元素节点，如果这个节点有父节点的话 */
export function _rmEl(el) {
    var oParent = el.parentNode
    if (oParent) {
        oParent.removeChild(el)
    }
}

export function _addClass(el, className) {
    var reg = new RegExp('' + className + '')
    if (!reg.test(el.className)) {
        // if dosent exsist
        el.className += (' ' + className)
    }
}

export function _rmClass(el, className) {
    var reg = new RegExp('' + className + '')
    if (reg.test(el.className)) {
        el.className = el.className.replace(reg, '')
    }
}

export function _language() {
    var type = navigator.appName
    var lang = ''
    if (type == 'Netscape') {
        lang = navigator.language
    } else {
        lang = navigator.userLanguage
    }
    lang = lang.substr(0, 2)
    switch (lang) {
        case 'en':
            break
        case 'zh':
            break
        default:
            lang = 'other'
    }
    return lang
}

export function _ajax(type, url, data, success, failed) {
    // 创建ajax对象
    if (typeof data == 'object') {
        var str = '';
        for (var key in data) {
            str += key + '=' + data[key] + '&';
        }
        data = str.replace(/&$/, '');
    }
    type = type.toUpperCase();
    if (type == 'GET') {
        if (data) {
            xhr.open('GET', url + '?' + data, true);
        } else {
            xhr.open('GET', url, true);
        }
        xhr.send();

    } else if (type == 'POST') {
        xhr.open('POST', url, true);
        // 如果需要像 html 表单那样 POST 数据，请使用 setRequestHeader() 来添加 http 头。
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.send(data);
    } else if (type == 'POSTJSON') {
        xhr.open('POST', url, true);
        // 如果需要像 html 表单那样 POST 数据，请使用 setRequestHeader() 来添加 http 头。
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }

    // 处理返回数据
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if (xhr.status == 200) {
                success(xhr.responseText);
            } else {
                if (failed) {
                    failed(xhr.responseText);
                }
            }
        }
    }
}

export function _statistics(url, silentTag) {
    var reg = /(http\:|https\:)/
    silentTag = silentTag || 'script'
    url = url.replace(reg, '')
    var silentDataUrlString = url
    var oTag = document.createElement(silentTag)
    oTag.setAttribute('src', silentDataUrlString)
    document.body.appendChild(oTag)
}

// 判断页面滚动方向
export function _scrollFunc() {
    var scrollAction = {
            x: 0,
            y: 0
        },
        scrollDirection
    var diffX = scrollAction.x - window.pageXOffset
    var diffY = scrollAction.y - window.pageYOffset
    // console.log(diffX, diffY)
    if (diffX < 0) {
        // Scroll right
        scrollDirection = 'right'
    } else if (diffX > 0) {
        // Scroll left
        scrollDirection = 'left'
    } else if (diffY < 0) {
        // Scroll down
        scrollDirection = 'down'
    } else if (diffY > 0) {
        // Scroll up
        scrollDirection = 'up'
    } else {
        // First scroll event
        // console.log(11111)
        scrollDirection = ''
    }
    scrollAction.x = window.pageXOffset
    scrollAction.y = window.pageYOffset
    // console.log(scrollAction, scrollDirection)
    return scrollDirection
}

// 文档高度
export function _getDocumentTop() {
    var scrollTop = 0,
        bodyScrollTop = 0,
        documentScrollTop = 0
    if (document.body) {
        bodyScrollTop = document.body.scrollTop
    }
    if (document.documentElement) {
        documentScrollTop = document.documentElement.scrollTop
    }
    scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop
    return scrollTop
}

// 可视窗口高度
export function _getWindowHeight() {
    var windowHeight = 0
    if (document.compatMode === 'CSS1Compat') {
        windowHeight = document.documentElement.clientHeight
    } else {
        windowHeight = document.body.clientHeight
    }
    return windowHeight
}

// 可视窗口宽度
export function _getWindowWidth() {
    var windowWidth = 0
    if (document.compatMode === 'CSS1Compat') {
        windowWidth = document.documentElement.clientWidth
    } else {
        windowWidth = document.body.clientWidth
    }
    return windowWidth
}

// 可视窗口高度 和 宽度
export function _getWinWH() {
    let ww = 0
    let wh = 0
    if (document.compatMode === "CSS1Compat") {
        ww = document.documentElement.clientWidth;
        wh = document.documentElement.clientHeight;
    } else {
        ww = document.body.clientWidth;
        wh = document.body.clientHeight;
    }
    return {
        ww,
        wh
    }
}

/**
 * 判断当前设备是否是 pad
 * @returns {boolean}
 * @private
 */
export function _isPad() {
    const ua = window.navigator.userAgent;

    // 如果当前设备是 iPad，则返回 true
    if (ua.indexOf('iPad') > -1) {
        return true;
    }

    // 如果当前设备是 iPad Pro，且 iOS 版本 >= 13，则返回 true
    if (ua.indexOf('Macintosh') > -1) {
        try {
            document.createEvent("TouchEvent");
            return true;
        } catch (e) {
        }
    }

    let {ww, wh} = _getWinWH()
    if (wh >= 1380 && ww >= 1900 || wh >= 1900 && ww >= 1380) {
        return true
    } else {
        return false
    }

    return false;
}

/**
 * 计算当前 webview 窄边除以宽边的比率，根据比率确定当前 webview 区域更接近 pad 还是 phone
 * 1. 如果宽高比大于 0.65，则可以认为当前 webview 区域更接近 pad，即返回 true
 * 2. 否则返回 false
 * @returns {boolean}
 * @private
 */
export function _isWebviewRatioLikeAPad() {
    let {ww, wh} = _getWinWH()
    let minSide = Math.min(ww, wh)
    let maxSide = Math.max(ww, wh)
    let ratio = minSide / maxSide;
    console.log('_isWebviewRatioLikeAPad: ', {ww, wh, ratio})
    return ratio > .65;
}

// 滚动条滚动高度
export function _getScrollHeight() {
    var scrollHeight = 0,
        bodyScrollHeight = 0,
        documentScrollHeight = 0
    if (document.body) {
        bodyScrollHeight = document.body.scrollHeight
    }
    if (document.documentElement) {
        documentScrollHeight = document.documentElement.scrollHeight
    }
    scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight
    return scrollHeight
}

export function _device() {
    var ua = navigator.userAgent
    var isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1 // android终端
    var isiOS = !!ua.match(/.+Mac OS X/) // ios终端
    return {
        isAndroid: isAndroid,
        isiOS: isiOS
    }
}

export function _toggleLogo() {
    var i
    var parm = _getUrlParamsObject()
    var rVersion = /(mal|mi)/ig
    if (parm && parm.sdk_version) {
        if (rVersion.test(parm.sdk_version)) {
            for (i = 0; i < _getEl('.logo').length; i++) {
                _rmClass(_getEl('.logo')[i], 'none')
            }
        }
    }
}

/*
 * Interfaces:
 * utf8 = utf16to8(utf16);
 * utf16 = utf8to16(utf8);
 */
export function _utf16to8(str) {
    var out, i, len, c
    out = ''
    len = str.length
    for (i = 0; i < len; i++) {
        c = str.charCodeAt(i)
        if ((c >= 0x0001) && (c <= 0x007F)) {
            out += str.charAt(i)
        } else if (c > 0x07FF) {
            out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F))
            out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F))
            out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F))
        } else {
            out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F))
            out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F))
        }
    }
    return out
}

export function _utf8to16(str) {
    var out, i, len, c
    var char2, char3
    out = ''
    len = str.length
    i = 0
    while (i < len) {
        c = str.charCodeAt(i++)
        switch (c >> 4) {
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
                // 0xxxxxxx
                out += str.charAt(i - 1)
                break
            case 12:
            case 13:
                // 110x xxxx 10xx xxxx
                char2 = str.charCodeAt(i++)
                out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F))
                break
            case 14:
                // 1110 xxxx 10xx xxxx 10xx xxxx
                char2 = str.charCodeAt(i++)
                char3 = str.charCodeAt(i++)
                out += String.fromCharCode(((c & 0x0F) << 12) |
                    ((char2 & 0x3F) << 6) |
                    ((char3 & 0x3F) << 0))
                break
        }
    }
    return out
}

export function _fnIsPortrait() {
    var isOrientation = ('orientation' in window && 'onorientationchange' in window),
        meta = ''
    // iframe中orientation并不准确
    if (isOrientation && window.self === window.top) {
        // eslint-disable-next-line no-undef
        if (orientation === 180 || orientation === 0) {
            meta = 'portrait'
        }
        // eslint-disable-next-line no-undef
        if (orientation === 90 || orientation === -90) {
            meta = 'landscape'
        }
    } else {
        if (window.innerWidth > window.innerHeight) { // 初始化判断
            meta = 'landscape'
        } else {
            meta = 'portrait'
        }
    }
    return meta === 'portrait'
}

export function _getQueryString(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    var r = window.location.search.substr(1).match(reg)
    if (r != null) return decodeURIComponent(r[2])
    return null
}

export function _tips(msg) {
    let tips_center = document.createElement('div')
    tips_center.textContent = msg
    tips_center.style.cssText = "font-size:100%; padding: .6em; background-color: rgba(0,0,0,.8); border-radius: 1em; position: absolute; left: 50%; top: 50%; -webkit-transform: translate3d(-50%,-50%,0); -moz-transform: translate3d(-50%,-50%,0); -ms-transform: translate3d(-50%,-50%,0); -o-transform: translate3d(-50%,-50%,0); transform: translate3d(-50%,-50%,0); "
    document.body.appendChild(tips_center)
    clearTimeout(this.timmer)
    this.timmer = setTimeout(function () {
        tips_center.textContent = ''
        tips_center.style.display = 'none'
    }, 3000)
}

/**
 * 一个定时监听器, 支持设置最大时限
 * @param condition 执行 callback 的条件, 必须是一个可以执行函数, 以确保每次可以拿到最新的状态
 * @param callback 符合条件时就会执行 callback
 * @param timeoutCallback 监听超时的情况下才会执行的回调函数()
 * @param maxDuration 最大监听时限, 超过时限就会自动停止监听, 默认 5 秒
 * @param maxRepeatTimes 最大重复次数, 和 maxDuration 共同控制监听器, 任何一个条件满足均会停止走超时逻辑
 * @param interval 监听频率
 */
export function _watchdog({
                              condition = () => false,
                              callback = () => {
                              },
                              timeoutCallback = () => {
                              },
                              maxDuration = 5000,
                              interval = 100
                          }) {
    if (condition && condition()) {
        callback()
    } else {
        let counter = 0
        let timerRepeat = null
        let timerOnce = null
        // 未超时的情况下循环调用 callback
        timerRepeat = setInterval(function () {
            ++counter
            if (condition && condition()) {
                console.log(`watchdog: 提前满足条件中止, 当前第${counter}次循环`, {condition: condition && condition()})
                clearTimeout(timerOnce)
                clearInterval(timerRepeat)
                callback()
            }
        }, interval)

        // 超时
        timerOnce = setTimeout(function () {
            console.log(`watchdog: 超时, 已经循环了${counter}次`, {condition: condition && condition()})
            clearInterval(timerRepeat)
            timeoutCallback()
        }, maxDuration)
    }
}

export function _preloadResource(url) {
    (new Image()).src = url
}

export function _logSuccess(msg, data = '') {
    console.log(`%c√ ${msg}: `, `color:green`, data)
}

export function _logWaring(msg, data = '') {
    console.log(`%c! ${msg}: `, `color:gold`, data)
}

export function _logError(msg, data = '') {
    console.log(`%c× ${msg}: `, `color:red`, data)
}

/**
 * 比较两个以小数点分隔的版本号, 并返回比较结果 (v1 大于, 等于或小于 v2)
 * @param {string|[]} v1 当前要比较的第一个版本号
 * @param {string|[]} v2 当前要比较的第二个版本号
 * @returns {number} 有三种返回结果:
 * 1. 返回 1, 表示 v1 的版本号大于 v2
 * 2. 返回 0, 表示 v1 的版本号等于 v2
 * 3. 返回 -1, 表示 v1 的版本号小于 v2
 * @example 举个栗子:
 * _compareVersion('10.11.0', '10.9.9') // 1
 * _compareVersion('12.2.0', '12.2.0') // 0
 * _compareVersion('9.999.999', '11.0.0') // -1
 */
export function _compareVersion(v1, v2) {
    console.log({v1, v2})
    if (typeof v1 === "undefined" || typeof v2 === "undefined") {
        console.error('请指定要对比的两个版本号', {v1, v2})
        return
    }

    v1 = v1.split('.')
    v2 = v2.split('.')
    const maxLength = Math.max(v1.length, v2.length)

    // 补全
    while (v1.length < maxLength) {
        v1.push('0')
    }
    while (v2.length < maxLength) {
        v2.push('0')
    }

    for (let i = 0; i < maxLength; i++) {
        let num1 = parseInt(v1[i])
        let num2 = parseInt(v2[i])

        if (num1 > num2) {
            return 1
        } else if (num1 < num2) {
            return -1
        }
    }

    return 0
}

/**
 * 针对 SDK API bug 的兼容补丁：
 * 如果当前为 iOS，且 SDK 版本 >=5.9.0，且 < 6.3.0，则需要作以下兼容：
 * 1. 在关闭阶段 SDK 提供的 convert 为 2 的情况下，提前将 convert 转换为 0
 * 问题原因：
 * 当最后关闭广告应该给用户奖励的时候，iOS SDK 给 H5 的 convert 是数字 1；
 * 当不该给奖励的时候，iOS SDK 给 H5 的 convert 是数字 2，这个阶段没有问题
 * 但 H5 之后透传给 SDK 的时候，由于某些历史版本 SDK 是直接将 convert 值转换为布尔类型，
 * 所以 SDK 会将 convert=2 不给奖励的情况也认为是 true 给奖励，最终回调开发者给了用户奖励
 * 修复方案：
 * H5 需要在 iOS >=590 且 < 630的版本中，把 2 转为 0，传给 SDK，这样就可以确保奖励逻辑的正确性，
 * iOS 会在 >=630 的版本中修复这个问题，H5 这种情况下默认不需要做特殊处理（透传即可）
 */
export function _checkIfCurrentVersionHasIOSAlwaysRewardProblem(currentVersion) {
    return _compareVersion(currentVersion, '5.9.0') >= 0
        && _compareVersion(currentVersion, '6.3.0') < 0
}

/**
 * Q: AndroidNoRewardProblem 是什么？
 * A: Android 奖励回调在 type4 组件的某些历史版本中存在问题
 *
 * 问题原因：
 * Android 二选一目前在最后关闭广告时给 H5 的关闭事件中没有传递奖励回调
 * （Android 是在 playComplete 阶段给的 convert），又由于 H5 目前是透传 SDK 的数据，
 * 所以 SDK 在开发者回调阶段拿到的 convert 为空（即用户不能获得奖励）
 *
 * 修复方案：
 * 目前的方案是针对安卓特定版本区间，保存 SDK 在 playComplete 阶段提供的 convert 和
 * reward 信息，在最终关闭时将 convert 相关信息传递给 SDK，此修复方案已经和 SDK 侧 @卢宝 确认
 */
export function _checkIfCurrentVersionHasAndroidNoRewardProblem(currentVersion) {
    let isInAndroidXVersion = _compareVersion(currentVersion, '12.2.0') >= 0
      && _compareVersion(currentVersion, '999.0.0') < 0;
    let isInAndroidNoXVersion = _compareVersion(currentVersion, '10.4.0') >= 0
      && _compareVersion(currentVersion, '12.0.0') < 0;
    console.log('isInAndroidXVersion: ', isInAndroidXVersion, 'isInAndroidNoXVersion: ', isInAndroidNoXVersion)
    return isInAndroidXVersion || isInAndroidNoXVersion;
}

/**
 * 将传入的对象序列化为 url 参数形式的字符串
 * @param o 传入的对象
 * @returns {string} 返回的序列化后的字符串
 */
export function _mergeParams(o) {
    let s = ''
    for (let k in o) {
        s += `&${k}=${o[k]}`
    }
    return s
}

/**
 * 生成并返回一些基础的页面上下文信息 - 同步
 */
export function _getBaseTemplateContext() {
    let baseData = {}

    // 初始化时间戳 (timestamp)
    baseData.ts = Date.now()
    // 初始化 endcard 模板名称 (material id), 如 endv4, 3like.v4
    baseData.mid = _getTemplateName()
    // 固定值 - 1表示endcard；2表示playable
    baseData.h5_type = 1
    // 标识当前页是否是 zip 包
    baseData.is_zip = _isFromZip() ? 1 : 0
    // 标识 "二选一模板样式优化方案" 是否开启 (model_type=1~n), 1-n的数字表示开启/其他值表示关闭
    baseData.model_type = encodeURIComponent(_getPageUrlParams('model_type'))
    // 标识 "二选一模板倒计时自动播放" 是否开启 (cltp=1~n), 1-n的数字表示开启/其他值表示关闭
    baseData.cltp = encodeURIComponent(_getPageUrlParams('cltp'))
    // 标识 "二选一模板倒计时自动播放文案变更" 是否开启 (cltp_type=1/2), 数字表示具体的文案类型
    baseData.cltp_type = encodeURIComponent(_getPageUrlParams('cltp_type'))
    // 标识 "二选一模板心跳上报" 是否开启 (xt=1), 1-n的数字表示开启/其他值表示关闭
    baseData.xt = encodeURIComponent(_getPageUrlParams('xt'))
    // 标识 "二选一模板多语言只支持简繁英三种" 是否开启 (lg=default), default开启/其他值表示关闭
    baseData.lg = encodeURIComponent(_getPageUrlParams('lg'))
    // 标识 "自动 storekit" 是否开启 (allow auto click), 1 开启/0 关闭
    baseData.alac = Number(_getPageUrlParams('alac')) === 1 ? 1 : 0
    // 标识 "全屏可点" 是否开启 (allow endcard fullscreen click), 1 开启/0 关闭
    baseData.alecfc = Number(_getPageUrlParams('alecfc')) === 1 ? 1 : 0
    // 标识 "猜你喜欢" 是否开启 (more offer), 1 开启/0 关闭
    baseData.mof = Number(_getPageUrlParams('mof')) === 1 ? 1 : 0
    // 标识 "批量上报" 是否开启, 1 开启/0 关闭
    baseData.n_imp = Number(_getPageUrlParams('n_imp')) === 1 ? 1 : 0
    // 标识当前操作系统 - 1 安卓, 2 iOS, 0 other
    baseData.platform = _device().isAndroid ? 1 : _device().isiOS ? 2 : 0
    // 当前浏览器 ua
    baseData.ua = encodeURIComponent(navigator.userAgent)

    return baseData
}

/**
 * 获取 SDK 中基础的上下文信息
 */
export function _getBaseSDKDataFromContext(SDKContext) {
    let baseSDKData = {}

    // 如果传入的 SDK 上下文为空, 则不再尝试拼装相关信息
    if (!SDKContext || !SDKContext.campaignList) {
        baseSDKData.baseSDKDataError = 1
        return baseSDKData
    }

    // 主 offer
    let mainCampaign = SDKContext.campaignList && SDKContext.campaignList[0]
    // 获取主 offer 的 request 维度 id
    let objImpUrl = _parseUrl(mainCampaign.only_impression_url)
    let mainCampaignRequestId = objImpUrl && objImpUrl.params && objImpUrl.params.k

    // 主 offer id
    baseSDKData.offer_id = mainCampaign.id
    // 主 offer 的 request id
    baseSDKData.r_id = mainCampaignRequestId
    // 主 offer 所在的 unit id
    baseSDKData.parent_unit = SDKContext.unit_id
    // 标识当前 appwall 是 "拆分 unit" 还是 "固定 unit"
    let mof_uid = _getPageUrlParams('mof_uid')
    if (mof_uid !== '') { // 拆分 unit
        baseSDKData.appwall_unit = mof_uid
        baseSDKData.app_id = SDKContext.device && SDKContext.device.appId
    } else { // 固定 unit
        baseSDKData.appwall_unit = _device().isAndroid ? 117361 : 51309
        baseSDKData.app_id = _device().isAndroid ? 92762 : 92763
    }
    // 国别码
    if (SDKContext.appSetting) {
        baseSDKData.country_code = SDKContext.appSetting.country_code
    }
    // SDK 版本
    baseSDKData.sdk_version = SDKContext.sdk_info || _getPageUrlParams('sdk_version')
    // 当前网络类型
    baseSDKData.network_type = SDKContext.device && SDKContext.device.network_type || ''

    return baseSDKData
}

/**
 * 获取当前 endcard 页的模板名称
 *
 * 描述:
 * 1. 优先从 url 参数中获取, 如果获取不到, 则尝试从 pathname 拿去后缀的文件名作为模板名称
 * 2. 当前取文件名的逻辑假定 location.pathname 中的文件名为类似 xxx.html 的形式(如: /xxx/xxx.html?xxx=xxx)
 *
 * @returns {string} 返回获取到的模板名称
 */
export function _getTemplateName() {
    let templateName;

    let page_interactive_type = _getPageUrlParams('page_interactive_type');

    if (page_interactive_type) {
        templateName = page_interactive_type
    } else {
        let filename = location.pathname.match(/\/[^\/]+(?=(\.\w+$))/)[0].substr(1);
        if (filename.length > 0) {
            templateName = filename
        }
    }

    return templateName;
}

// 用来标识当前页面是否来自 zip 包, 如果是 file: 协议则认为当前页面是从本机解压的 zip 包中打开的
export function _isFromZip() {
    return location.protocol === 'file:'
}

/**
 * 以新建 scrip 标签的方式进行一次 get 请求, 一般用于通常的埋点和业务上报
 * @param url
 */
export function _reportUrl(url) {
    let script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.src = url;
    document.body.appendChild(script);
}

/**
 * 根据浏览器语言设置走不同的回调 (目前支持: 简 繁 英  )
 * @param cbAnyLanguage 如果设置了此回调，则无论系统配置了何种语言，都会在执行完当前语言回调之后，再调用此方法
 * @param cbSimp 浏览器语言设置为简体中文时的回调
 * @param cbTrad 浏览器语言设置为繁体中文时的回调
 * @param cbJP 浏览器语言设置为日文时的回调
 * @param cbGerman 浏览器语言设置为德语时的回调
 * @param cbKorean 浏览器语言设置为韩语时的回调
 * @param cbFrench 浏览器语言设置为法语时的回调
 * @param cbArabic 浏览器语言设置为阿拉伯语时的回调
 * @param cbRussian 浏览器语言设置为俄语时的回调
 * @param cbDefault 如果没有匹配到以上语言，则会走这个默认回调
 * @private
 */
export function _doSthBaseOnLanguage({cbAnyLanguage, cbSimp, cbTrad, cbJP, cbGerman, cbKorean, cbFrench, cbArabic, cbRussian, cbDefault}) {
    let lang = navigator.language.toLowerCase();
    let langPrefix = lang.split('-')[0];
    let cbDefaultSafely = function (lang) {
        typeof cbDefault === 'function' && cbDefault(lang)
    };

    // 根据 language 的前缀走不同的回调逻辑
    switch (langPrefix) {
        // 汉语
        case 'zh':
            // 中文繁体
            if (lang === 'zh-hk' || lang === 'zh-tw') {
                typeof cbTrad === 'function' ? cbTrad(lang) : cbDefaultSafely(lang)
            } else {
                // 中文简体 'zh' 'zh-CN'
                typeof cbSimp === 'function' ? cbSimp(lang) : cbDefaultSafely(lang)
            }
            break;
        // 日语 'ja' 'ja-jp'
        case 'ja':
            typeof cbJP === 'function' ? cbJP(lang) : cbDefaultSafely(lang)
            break;
        // 德语 'de' 'de-de'
        case 'de':
            typeof cbGerman === 'function' ? cbGerman(lang) : cbDefaultSafely(lang)
            break;
        // 韩语 'ko' 'ko-kr'
        case 'ko':
            typeof cbKorean === 'function' ? cbKorean(lang) : cbDefaultSafely(lang)
            break;
        // 法语 'fr-fr'(France) 'fr-ca'(Canada) 'fr-be'(Belgique) 'fr-ch'(Suisse)
        case 'fr':
            typeof cbFrench === 'function' ? cbFrench(lang) : cbDefaultSafely(lang)
            break;
        // 阿拉伯语
        case 'ar':
            typeof cbArabic === 'function' ? cbArabic(lang) : cbDefaultSafely(lang)
            break;
        // 俄语 'ru' 'ru-ru'
        case 'ru':
            typeof cbRussian === 'function' ? cbRussian(lang) : cbDefaultSafely(lang)
            break;
        // 英语
        default:
            cbDefaultSafely(lang)
            break;
    }

    // 如果设置了此回调，则无论系统配置了何种语言，都会在执行完当前语言回调之后，再调用此方法
    typeof cbAnyLanguage === 'function' && cbAnyLanguage()
}